import './App.css';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Logo from "./come-on-da-logo.png";
import React, { useEffect, useState } from "react";
import Service from "./api/service";

const Games = () => {
  const [loading, setLoading] = useState(false);
  const [gameData, setGameData] = useState([]);

  const getGames = () => {
    setLoading(true);
    Service.getGames()
      .then((data) => {
        if (data?.data?.status === "success") {
          setGameData(data.data?.response);
        } else {
          console.log("Invalid page data structure");
        }
      })
      .catch((err) => {
        console.log("Fetch error:", err);
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    getGames();
  }, []);

  return (
    <div style={{ background: 'linear-gradient(to right bottom, #FFFFFF, #D6FBE0 )', minHeight: '100vh' }}>
      <Container>
        <section>
          <div className="text-center mb-4 pb-2">
            <Box
              component="img"
              src={Logo}
              alt="Comeonda"
              width="170px"
              height="170px"
            />
          </div>

          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: "20px",
              justifyContent: "center"
            }}
          >
            {loading ? (
              <p>Loading games...</p>
            ) : (
              gameData?.filter((g) => g.url)?.map((game, index) => (
                <div
                  key={index}
                  style={{
                    width: "180px",
                    cursor: "pointer",
                    textAlign: "center"
                  }}
                  onClick={() => window.open(`/gamePlay?url=${encodeURIComponent(game.url)}`, '_blank')}
                >
                  <img
                    src={game.thumb}
                    alt={game.name}
                    style={{
                      width: "100%",
                      borderRadius: "12px",
                      border: "2px solid #ccc"
                    }}
                  />
                  <p style={{ fontWeight: "bold", marginTop: "8px" }}>{game.name}</p>
                </div>
              ))
            )}
          </div>
        </section>
      </Container>
    </div>
  );
};

export default Games;
